import styles from './RunDates.module.css';
import { assets } from '@round/whitelabel-ui';

const { ArrowRight: ArrowIcon } = assets;

type Props = {
    startDate: string;
    endDate: string;
};

const RunDates = ({ startDate, endDate }: Props) => {
    if (!startDate && !endDate) {
        return <>-</>;
    }

    return (
        <div className={styles.container}>
            <span>{startDate}</span>
            <ArrowIcon className={styles.icon} />
            <span>{endDate}</span>
        </div>
    );
};

export default RunDates;
